import React, { useEffect, useContext, useRef } from 'react';
import FadeIn from 'react-fade-in';
import { GlobalHotKeys } from 'react-hotkeys';
import { useObserver } from 'mobx-react-lite';

import { quickDrawerFocus, renderQuickDrawerLoading } from '../../../../_shared/QuickDrawer';
import QuickDrawerHeader from '../../../../_shared/QuickDrawerHeader';
import RichTextEditor from '../../../../_shared/RichTextEditor';

import PretestTemplateCreateStore from '../../../../../../stores/PretestTemplateCreateStore';
import QuickDrawerStore from '../../../../../../stores/QuickDrawerStore';

import * as ErrorMessages from '../../../../../../constants/errorMessages';
import * as fn from '../../../../../../utilities/_functions';
import * as oh from '../../../../../../utilities/operationHelper';


import './NewPretestTemplate.scss';

function NewPretestTemplate(props) {
    const isMounted = useRef(true);
    const focusTimer = useRef(null);
    const pretestTemplate = useContext(PretestTemplateCreateStore);
    const quickDrawer = useContext(QuickDrawerStore);

    useEffect(() => {
        focusTimer.current = setTimeout(() => {
            quickDrawerFocus(props.drawer);
        }, 100)

        return () => {
            isMounted.current = false;
            if (focusTimer.current) { clearTimeout(focusTimer.current); focusTimer.current = null; }
        }
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (pretestTemplate.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleSubmit = event => {
        event.preventDefault();
        pretestTemplate.save()
            .then(data => {
                if (isMounted.current) {
                    if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                        props.onSuccess(event, data);
                    }
                }
            })
    }

    const handlePretestTypeChange = event => {
        pretestTemplate.data.pretestTypeId = event.target.value;
        pretestTemplate.hasUnsavedChanges = true;
    }

    const handleNameChange = event => {
        pretestTemplate.data.name = event.target.value;
        pretestTemplate.hasUnsavedChanges = true;
    }

    const handleDescriptionChange = content => {
        const html = content;
        pretestTemplate.data.descriptionHtml = ((html === '<p><br></p>') ? null : html);
        pretestTemplate.hasUnsavedChanges = true;
    }

    const handleLaunchReaderChange = event => {
        pretestTemplate.data.launchReader = !pretestTemplate.data.launchReader;
        pretestTemplate.hasUnsavedChanges = true;
    }

    return useObserver(() => <>
        <>
            {
                (props.drawer === quickDrawer.drawerOpened) ?
                    <GlobalHotKeys
                        keyMap={{
                            close: ['esc'],
                        }}
                        handlers={{
                            close: event => {
                                handleCancel(event)
                            },
                        }}
                        allowChanges={true}
                    /> : null
            }
        </>
        <form onSubmit={handleSubmit}>
            <fieldset disabled={pretestTemplate.isSaving}>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={oh.getIcon('pretest-template', 'default')}
                        action='New'
                        category='Pretest Template'
                        onCancel={handleCancel}
                    />
                    <div className='quick-drawer-body'>
                        {
                            pretestTemplate.isReady ?
                                <FadeIn>
                                    <div className='new-pretest-template body-content'>
                                        <section>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <label className='required' htmlFor='new-pretest-template-type'><small>Pretest Type</small></label>
                                                        <select
                                                            id='new-pretest-template-type'
                                                            className='custom-select form-control'
                                                            value={pretestTemplate.data.pretestTypeId ? pretestTemplate.data.pretestTypeId : ''}
                                                            onChange={handlePretestTypeChange}
                                                        >
                                                            <option value=''></option>
                                                            {
                                                                pretestTemplate.pretestTypes.map((option, di) => {
                                                                    return <option key={`pretest_template_type_${di}`} value={option.id}>{option.name}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <label className='required' htmlFor='new-pretest-template-name'><small>Name</small></label>
                                                        <input
                                                            id='new-pretest-template-name'
                                                            type='text'
                                                            maxLength={100}
                                                            className='form-control'
                                                            autoComplete={'off'}
                                                            value={pretestTemplate.data.name ? pretestTemplate.data.name : ''}
                                                            onChange={handleNameChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <label htmlFor='new-pretest-template-description'><small>Description</small></label>
                                                        <RichTextEditor
                                                            mode='none'
                                                            disableTab={true}
                                                            value={pretestTemplate.data.descriptionHtml ? pretestTemplate.data.descriptionHtml : ''}
                                                            onChange={handleDescriptionChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    <div className='form-group mb-4'>
                                                        <div
                                                            className={'custom-control custom-checkbox mb-2'}
                                                        >
                                                            <input
                                                                id='new-pretest-template-launch-reader'
                                                                type='checkbox'
                                                                name='new-pretest-template-launch-reader'
                                                                className='custom-control-input'
                                                                checked={pretestTemplate.data.launchReader}
                                                                onChange={handleLaunchReaderChange}
                                                            />
                                                            <label
                                                                htmlFor='new-pretest-template-launch-reader'
                                                                className='custom-control-label'
                                                            >
                                                                Launch reader
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </FadeIn> : renderQuickDrawerLoading()
                        }
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-4'></div>
                            <div className='col-8'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={handleCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-success'
                                    >Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </>)
}

export default NewPretestTemplate;